import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { HeatIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentHeatPumpForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } = useFormModel<
        ChangeNames.INCREASE_CURRENT_ELECTRIC_HEAT_PUMP
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Wärmeanlage
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            z. B. Speicherheizung, Wärmepumpe etc.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sofern bereits heute eine Wärmepumpe an der Bauadresse existiert, ist diese hier zu erfassen. Die Option ist nur zu aktivieren, wenn Sie bereits eine bestehende Wärmepumpe am Netz angeschlossen haben.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Möchten Sie ausschließlich eine weitere Wärmepumpe beantragen, nutzen Sie hierfür bitte den Prozess "Verbrauchsgeräte".
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentElectricHeatPump.value.installed}
                        {...getFieldProps("increaseCurrentElectricHeatPump.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.increaseCurrentElectricHeatPump.value.installed = checked;
                                values.increaseCurrentElectricHeatPump.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentElectricHeatPump.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseCurrentElectricHeatPump.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricHeatPump.value.demand.unit}
                            value={values.increaseCurrentElectricHeatPump.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentElectricHeatPump.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricHeatPump.error != null}
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={values.increaseCurrentElectricHeatPump.value.notKnown}
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentElectricHeatPump.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
